export enum EDiningAlternative {
  Takeaway = 'takeaway',
  EatOut = 'eat-out',
}
